export const BRAND = {
  name: "Zingly Dosa",
  tagline: "Homemade South Indian Food",
  logo: "https://customer-assets.emergentagent.com/job_fresh-batter-2/artifacts/df4e18zy_ChatGPT%20Image%20Jun%2027%2C%202026%2C%2004_52_52%20PM.png",
  phone: "+91 88061 15588",
  phoneRaw: "918806115588",
  location: "Beed, Maharashtra",
  hours: "7:00 AM - 10:00 PM",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Beed+Maharashtra",
  swiggyUrl: "https://www.swiggy.com/search?query=Zingly%20Dosa%20Beed",
  zomatoUrl: "https://www.zomato.com/beed/restaurants?q=Zingly%20Dosa",
};

export const waOrder = (item) => {
  const base = `https://wa.me/${BRAND.phoneRaw}`;
  const msg = item
    ? `Hello Zingly Dosa! I'd like to order: ${item}. Please share availability & delivery details.`
    : `Hello Zingly Dosa! I'd like to place an order. Please share today's menu.`;
  return `${base}?text=${encodeURIComponent(msg)}`;
};

export const MENU = [
  {
    id: "plain-dosa",
    title: "Plain Dosa",
    price: 80,
    description: "Golden crispy dosa served with chutney & sambar.",
    longDescription: "Hand-poured on a hot tawa, paper-thin and golden. Made from a 24-hour fermented batter for that signature tang. Served with fresh coconut chutney and piping hot sambar.",
    ingredients: ["Fermented rice & urad batter", "Coconut chutney", "Hot sambar", "A touch of pure ghee"],
    image: "https://images.unsplash.com/photo-1694849789325-914b71ab4075?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxjcmlzcHklMjBkb3NhfGVufDB8fHx8MTc4MjU2OTE2N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "masala-dosa",
    title: "Masala Dosa",
    price: 100,
    description: "Crispy dosa stuffed with delicious potato masala.",
    longDescription: "Our signature dish. Crispy dosa wrapped around a soft, mildly spiced potato masala tempered with mustard seeds, curry leaves and onions. The crowd favourite.",
    ingredients: ["Fermented dosa batter", "Spiced potato masala", "Curry leaves & mustard tempering", "Chutney + sambar"],
    image: "https://images.pexels.com/photos/12392915/pexels-photo-12392915.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    badge: "Best Seller",
  },
  {
    id: "idli-sambar",
    title: "Idli Sambar",
    price: 60,
    description: "Soft idlis served with hot sambar & coconut chutney.",
    longDescription: "Pillowy soft steamed rice cakes, fluffy and light. Plated with our slow-simmered sambar and freshly ground coconut chutney. Comfort in every bite.",
    ingredients: ["Steamed rice & lentil idlis", "Slow-cooked sambar", "Coconut chutney", "Ghee drizzle"],
    image: "https://images.pexels.com/photos/35514447/pexels-photo-35514447.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const REVIEWS = [
  {
    name: "Rahul Patil",
    initials: "RP",
    text: "One of the crispiest dosas I have ever eaten. Fresh chutney and delicious sambar. Tastes truly homemade.",
    rating: 5,
  },
  {
    name: "Priya Sharma",
    initials: "PS",
    text: "Homemade taste with premium quality. The batter is so fresh you can tell it's made daily. Highly recommended.",
    rating: 5,
  },
  {
    name: "Amit Kulkarni",
    initials: "AK",
    text: "Amazing Masala Dosa and quick delivery. Hot, crispy and packed beautifully. Will definitely order again!",
    rating: 5,
  },
];

export const STATS = [
  { value: 100, suffix: "%", label: "Fresh Daily" },
  { value: 3, suffix: "", label: "Signature Dishes" },
  { value: 30, suffix: "min", label: "Fast Delivery" },
];
